import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export interface User {
  userId: string | null;
  userImages: {
    key: string
    url: string
  }[] | null
  userHoroscope: {
    key: string
    url: string
  } | null | undefined
  first_name: string | null;
  last_name: string | null;
  mobile_Number: string | null;
  country_code: string | null;
  gender: string | null;
  isAuthenticated?: boolean;
  token?: string | null;
  is_premium?: boolean
  active_plan?: any;
  email?: string | null;
  maxProfileViewLimit: number
  profileViewCount: number;
  isLegitPremium?: boolean;
}

const initialState: User = {
  userId: null,
  userImages: null,
  userHoroscope: null,
  first_name: null,
  last_name: null,
  mobile_Number: null,
  country_code: null,
  gender: null,
  isAuthenticated: false,
  token: null,
  is_premium: false,
  email: null,
  maxProfileViewLimit: 0,
  profileViewCount: 0,
  isLegitPremium: false,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    login(state, action: PayloadAction<Partial<User>>) {
      state.first_name = action.payload.first_name as string;
      state.last_name = action.payload.last_name as string;
      state.country_code = action.payload.country_code as string;
      state.mobile_Number = action.payload.mobile_Number as string;
      state.email = action.payload.email as string;
      state.userId = action.payload.userId as string;
      state.gender = action.payload.gender ?? null;
      state.isAuthenticated = true;
      state.userHoroscope = action.payload.userHoroscope;
      state.token = action.payload.token;
      state.userImages = action.payload.userImages as any;
    },
    logout() {
      localStorage.removeItem("is_profile_completed")
      return initialState
    },
    updateProfileViewStatus(state, action: PayloadAction<{
      maxProfileViewLimit?: User['maxProfileViewLimit'];
      profileViewCount: User['profileViewCount'];
    }>) {
      const { maxProfileViewLimit, profileViewCount } = action.payload
      if (maxProfileViewLimit !== undefined) {
        state.maxProfileViewLimit = maxProfileViewLimit
      }
      if (profileViewCount !== undefined) {
        state.profileViewCount = profileViewCount
      }
    },
    updateUserDetail(state, action: PayloadAction<Partial<User>>) {
      const {
        first_name,
        last_name,
        gender,
        country_code,
        mobile_Number,
        is_premium,
        userImages,
        userHoroscope,
        isLegitPremium,
      } = action.payload

      if (first_name) {
        state.first_name = first_name
      }
      if (last_name) {
        state.last_name = last_name
      }
      if (gender) {
        state.gender = gender
      }
      if (country_code) {
        state.country_code = country_code
      }
      if (mobile_Number) {
        state.mobile_Number = mobile_Number
      }
      if ([true, false].includes(Boolean(is_premium))) {
        state.is_premium = is_premium
      }
      if (userImages) {
        state.userImages = userImages
      }
      if (userHoroscope) {
        state.userHoroscope = userHoroscope
      }
      if (isLegitPremium !== undefined) {
        state.isLegitPremium = isLegitPremium
      }
    }
  },
});

export const {
  login,
  logout,
  updateUserDetail,
  updateProfileViewStatus,
} = userSlice.actions;

export default userSlice.reducer;